import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Map } from 'immutable'

import config from '../../../../../../../../../config'

import { BLOCK_TYPE } from './constants'

const MODULE_KEY = config.modules.report.key

function mapStateToProps(state, hocProps) {
    const activeReportType = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', 'reports', 'active'], null)
    const blocks = state.getIn(
        ['authorization', 'accessRights', MODULE_KEY, 'custom', 'reports', activeReportType, 'blocks'],
        Map()
    )

    return {
        type: blocks.getIn([hocProps.block, 'parameters', 'type'], BLOCK_TYPE.BASIC),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
